import React from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { DisplayBox } from "../components";
import { AffiliateSettingInterface, ApiHelper, ArrayHelper, CommissionRowInterface, UserHelper } from "../helpers";
import { CommissionCheckDetails } from "./components/CommissionCheckDetails";
import { Commissions } from "./components/Commissions";

export const CommissionCheckPage: React.FC = () => {
  const { id: paramId } = useParams<{ id: string }>();
  const id = parseInt(paramId, 0);

  const [affiliateSettings, setAffiliateSettings] = React.useState<AffiliateSettingInterface[]>(null);
  const [rowsToAdd, setRowsToAdd] = React.useState<{ rows: CommissionRowInterface[], affiliateCode: string }>(null);
  const [rowsToRemove, setRowsToRemove] = React.useState<{ rows: CommissionRowInterface[], affiliateCode: string }>(null);
  const [allAddableCommissions, setAllAddableCommissions] = React.useState<CommissionRowInterface[]>(null);
  const [allCommissions, setAllCommissions] = React.useState<CommissionRowInterface[]>(null);

  const init = async () => {
    const data = await ApiHelper.get<AffiliateSettingInterface[]>("/affiliateSettings") || [];
    if (data.length > 0) {
      setAffiliateSettings(data);
      ApiHelper.get<CommissionRowInterface[]>("/affiliateSettings/commissions/withCode").then(d => {
        setAllAddableCommissions(d || [])
      });
      ApiHelper.get<CommissionRowInterface[]>("/affiliateSettings/commissions/withCode/" + id).then(d => setAllCommissions(d || []));
    }
  }

  React.useEffect(() => { init() }, []) //eslint-disable-line

  const getCommissions = () => {
    const result: React.ReactElement[] = [];

    for (let s of affiliateSettings || []) {
      if (allCommissions) {
        let first = true;
        const commissions: CommissionRowInterface[] = ArrayHelper.getAllArray(allCommissions || [], "referredByCode", (first) ? [s.code, null, ""] : [s.code]);;
        result.push(<Commissions affiliateSetting={s} checkId={id}
          rowsToAdd={(rowsToAdd?.affiliateCode === s.code) ? rowsToAdd.rows : null}
          onAction={handleRemove}
          actionName="Remove"
          commissions={commissions}
        />)
        first = false;
      }
    }

    return result;
  }

  const handleRemove = (rows: CommissionRowInterface[], setting: AffiliateSettingInterface) => {
    const invoiceIds = ArrayHelper.getIds(rows, "invoiceId");
    ApiHelper.post("/commissions/updateCheck", { invoiceIds, checkId: null, accountId: affiliateSettings[0].accountId })
    setRowsToRemove({ rows, affiliateCode: setting.code });
  }

  const handleAdd = (rows: CommissionRowInterface[], setting: AffiliateSettingInterface) => {
    const invoiceIds = ArrayHelper.getIds(rows, "invoiceId");
    ApiHelper.post("/commissions/updateCheck", { invoiceIds, checkId: id, accountId: affiliateSettings[0].accountId })
    setRowsToAdd({ rows, affiliateCode: setting.code });
  }

  const getFirstCommissions = () => {
    let otherCodes: string[] = [];
    let first = true;
    for (let s of affiliateSettings || []) {
      if (!first) otherCodes.push(s.code);
      first = false;
    }
    const result: CommissionRowInterface[] = [];
    allAddableCommissions?.forEach(c => {
      //console.log("Checkin", c.referredByCode, otherCodes, !c.referredByCode || otherCodes.indexOf(c.referredByCode) === -1)
      if (!c.referredByCode || otherCodes.indexOf(c.referredByCode) === -1) result.push(c);
    });
    return result;
  }

  const getAddable = () => {
    let result = <></>;
    if (UserHelper.checkAccess("admin")) {
      const data: React.ReactElement[] = [];
      let first = true;
      for (let s of affiliateSettings || []) {
        if (allAddableCommissions) {

          const addableCommissions: CommissionRowInterface[] = (first) ?
            getFirstCommissions()
            : ArrayHelper.getAll(allAddableCommissions || [], "referredByCode", s.code);
          //ArrayHelper.getAllArray(allAddableCommissions || [], "referredByCode", [s.code]);
          data.push(<Commissions affiliateSetting={s} onAction={handleAdd} actionName="Add" rowsToAdd={(rowsToRemove?.affiliateCode === s.code) ? rowsToRemove.rows : null} commissions={addableCommissions} />)
          first = false;
        }
      }

      result = <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Addable Commissions">
        {data}
      </DisplayBox>
    }
    return result;
  }

  return (
    <>
      <h1><i className="fas fa-money-bill-wave"></i> Commission Check Details</h1>
      <Row>
        <Col>
          <CommissionCheckDetails id={id} />
          <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Included Commissions">
            {getCommissions()}
          </DisplayBox>

        </Col>
        <Col>
          {getAddable()}


        </Col>
      </Row>
    </>
  );
};